module.exports = __webpack_public_path__ + "img/Cookie_1_resize_27.d5f2dd95.png";